<template>
  <transition name="popup">
    <div class="popup-back">
      <div class="popup defend-pop-wrap dark-theme">
        <div class="popup-button-close">
          <a @click.prevent="clickClose()" href="#">
            <img src="../../assets/images/common/btn-popup-close.png" alt="btn-close">
          </a>
        </div>

        <div class="pop-contents tAc">
          <h1>결제수단 변경</h1>
          <span class="pop-txt">결제수단을 변경 하시겠어요?</span>
          <div class="gray-back">
        <span class="pop-txt">
          결제수단을 변경하시더라도<br>
          <b>결제가 끊기거나 결제일이 변경되지 않으니</b><br>
          안심하고 변경하세요.<br>
          다음 결제일에 <b>변경하신 수단으로 자동 결제</b>됩니다.
        </span>
          </div>
          <i class="v-gap10">공백</i>
          <div class="tAl">
        <span class="pop-dotted payment-method-change-exclamation">
          <i class="icon-dotted"></i>
          신용카드로만 변경 가능한 점 참고해주세요.<br>
          ex) 휴대폰결제 등 기타 결제수단 &gt; 신용카드 , 신용카드 &gt; 신용카드
        </span>
          </div>
          <div class="tAc">
            <div class="btn-gray-line ftl">
              <a href="#" @click.prevent="clickClose()">취소</a>
            </div>
            <div class="btn-purple ftr">
              <a href="#" @click.prevent="changePaymentMethod(data)">결제수단 변경</a>
            </div>
          </div>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
import cookie from '@/common/utils/cookie'
import constant from '@/common/resources/constant'

export default {
  props: {
    data: {
      type: Object
    },
    close: {
      type: Function
    }
  },
  methods: {
    clickClose () {
      this.close()
    },
    changePaymentMethod (data) {
      let returnUrl = window.location.protocol + '//' + window.location.hostname + '/callback.html?action=ClosePopupAndReload'

      let popup = window.open(constant.URL_BILLING_CHANGE_PAYMENT_METHOD +
          '?credential=' + encodeURIComponent(cookie.getCredential()) +
          '&deviceTypeId=pc' +
          '&transactionId=' + encodeURIComponent(data.transactionid) +
          '&returnUrl=' + encodeURIComponent(returnUrl),
      'changePaymentPopup',
      'width=700, height=780, scrollbars=yes')
      popup.window.focus()
    }
  }
}
</script>

<style lang="css">
  .defend-pop-wrap.dark-theme .pop-contents{
    background-color: #252525;
  }
</style>
